var iconLibraryIdManifest = {
  fab: '31Qfulu3H7L',
  far: '21N4j-r1ksL',
  fas: '41-zmA48tEL'
};

export { iconLibraryIdManifest as i };
//# sourceMappingURL=iconLibraryIdManifest-CQUF_yH1-CQUF_yH1.js.map
